import { AbstractInteractorTool } from './tools';
import { EditWallAddition } from './../cmd/EditWallAddition';
import { Util } from '../utils/Util';
import { WallAdditionInteractors } from './WallAdditionInteractors';
import { ElementChangedFlags } from '@egr/wcf/modules/core/mdl';
export class MoveWallAddition extends AbstractInteractorTool {
    constructor(pRoomManager) {
        super(pRoomManager);
        this.mCommand = null;
        this.mDistanceFeedback = null;
    }
    initialize(pAddition) {
        this.mAddition = pAddition;
        this.mCommand = new EditWallAddition(this.mRoomManager, this.mAddition);
        //this.mRoomManager.beginInteraction();
    }
    stop() {
        if (this.mCommand != null) {
            this.mCommand.cancel();
            this.mCommand = null;
        }
        if (this.mAddition != null && this.mAddition.type == "PictureFrame") {
            // refresh 2d geometry after possible change of height
            this.mAddition.updateGeometry();
        }
        this.mRoomManager.endInteraction();
        super.stop();
    }
    //// protected /////////////////////////////////////////////////////////////////////////////
    startPos(pPos) {
        //
    }
    updatePointerPosition(pPos) {
        let t2dPos = Util.to2d(pPos);
        let tNearestWall = this.mRoomManager.getNearestWall(t2dPos);
        if (tNearestWall == null)
            return;
        if (tNearestWall != this.mAddition.wall)
            this.mAddition.attachToWall(tNearestWall, t2dPos);
        else {
            this.mAddition.setPosition(t2dPos);
            if (this.mAddition.type == "PictureFrame" && this.mRoomManager.viewMode == 7) {
                this.mAddition.setFloorOffset(pPos.y, false);
            }
        }
        this.mApp.rendering.notifyModelInteraction();
        if (this.mView != null)
            this.mView.viewer.requestRenderFrame();
    }
    finish() {
        if (this.mCommand == null)
            return;
        this.mApp.commands.executeCommand(this.mCommand).then(() => {
            if (this.mAddition != null) {
                this.mAddition.notifyChange(ElementChangedFlags.PropertyValues |
                    ElementChangedFlags.BoundingBox);
            }
            this.mCommand = null;
            this.stop();
        });
    }
    prepareFeedback() {
        super.prepareFeedback();
        this.mDistanceFeedback = new WallAdditionInteractors(this.mRoomManager, this.mAddition);
        this.mDistanceFeedback._updateDistInteractors();
    }
    clearFeedback() {
        super.clearFeedback();
        if (this.mDistanceFeedback != null) {
            this.mDistanceFeedback.clear();
            this.mDistanceFeedback = null;
        }
    }
    updateFeedback() {
        super.updateFeedback();
        if (this.mDistanceFeedback != null)
            this.mDistanceFeedback._updateDistInteractors();
    }
}
